import whatsappLogo from '../assets/whatsapp-logo.svg';

const WHATSAPP_URL = 'https://wa.me/919351275556?text=Hi%2C%20I%27d%20like%20to%20enquire%20about%20your%20India-UK%20tax%20advisory%20services.';

const WhatsAppFloating = () => {
  return (
    <a
      data-testid="whatsapp-floating"
      href={WHATSAPP_URL}
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Chat on WhatsApp"
      className="fixed bottom-6 right-6 z-50 flex items-center justify-center w-14 h-14 rounded-full transition-all duration-200 hover:scale-110 active:scale-95"
      style={{
        backgroundColor: '#25D366',
        boxShadow: '0 8px 24px rgba(37,211,102,0.40)',
      }}
    >
      <img src={whatsappLogo} alt="WhatsApp" className="w-10 h-10" />
    </a>
  );
};

export default WhatsAppFloating;
